import React, { useContext, useEffect, useRef, useState } from "react";

import clsx from "clsx";
import { useHistory, useParams } from "react-router-dom";
import { useTimezone } from "../../hooks/useTimezone";
import Avatar from "@material-ui/core/Avatar";
import Badge from "@material-ui/core/Badge";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Typography from "@material-ui/core/Typography";
import { blue, green, orange, red } from "@material-ui/core/colors";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

import { Tooltip, Menu, MenuItem, ListItemIcon } from "@material-ui/core";
import { v4 as uuidv4 } from "uuid";
import { AuthContext } from "../../context/Auth/AuthContext";
import { TicketsContext } from "../../context/Tickets/TicketsContext";
import { WhatsAppsContext } from "../../context/WhatsApp/WhatsAppsContext";
import toastError from "../../errors/toastError";
import api, { getProfilePicUrl } from "../../services/api";
import MarkdownWrapper from "../MarkdownWrapper";

import AndroidIcon from "@material-ui/icons/Android";
import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import PeopleIcon from "@material-ui/icons/People";
import ReplayIcon from "@material-ui/icons/Replay";
import VisibilityIcon from "@material-ui/icons/Visibility";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ScheduleIcon from "@material-ui/icons/Schedule";
import ChatIcon from "@material-ui/icons/Chat";
import LockIcon from "@material-ui/icons/Lock";
import ContactTag from "../ContactTag";
import ScheduleModal from "../ScheduleModal";
import ConfirmationModal from "../ConfirmationModal";
import { toast } from "react-toastify";
import TicketMessagesDialog from "../TicketMessagesDialog";
import TransferTicketModalCustom from "../TransferTicketModalCustom";
import { getInitials } from "../../helpers/getInitials";
import { generateColor } from "../../helpers/colorGenerator";

const useStyles = makeStyles((theme) => ({
  ticket: {
    position: "relative",
    padding: theme.spacing(1, 1.5), // ✅ REDUCIDO: De 1.5,2 a 1,1.5
    paddingTop: theme.spacing(1.5), // ✅ REDUCIDO: De 2.5 a 1.5
    marginBottom: theme.spacing(0.25), // ✅ REDUCIDO: De 0.5 a 0.25
    borderRadius: "12px",
    transition: "all 0.2s ease",
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.mode === 'dark' ? '#374151' : '#e5e7eb'}`,
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    minHeight: "auto", // ✅ NUEVO: Permitir que el ticket se ajuste al contenido
    "&:hover": {
      backgroundColor: theme.mode === 'dark' ? '#374151' : '#f9fafb',
      boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
      transform: "translateY(-1px)",
    },
    "&.Mui-selected": {
      backgroundColor: theme.palette.primary.main + "15",
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 2px ${theme.palette.primary.main}40`,
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(0.75, 1), // ✅ REDUCIDO: De 1,1.5 a 0.75,1
      paddingTop: theme.spacing(1.25), // ✅ REDUCIDO: De 2 a 1.25
      borderRadius: "8px",
    },
  },

  pendingTicket: {
    cursor: "unset",
    opacity: 0.9,
  },
  queueTag: {
    background: "#FCFCFC",
    color: "#000",
    marginRight: 4,
    marginBottom: 2,
    padding: "4px 8px",
    fontWeight: 600,
    borderRadius: 6,
    fontSize: "0.75em",
    whiteSpace: "nowrap",
    display: "inline-block",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  noTicketsDiv: {
    display: "flex",
    height: "100px",
    margin: 40,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  newMessagesCount: {
    position: "absolute",
    alignSelf: "center",
    marginRight: 8,
    marginLeft: "auto",
    top: "-4px", // ✅ AJUSTADO: De 4px a -4px - Más abajo, cerca del borde superior izquierdo del avatar
    left: "-4px", // ✅ AJUSTADO: De 8px a -4px - Más cerca del borde izquierdo del avatar
    borderRadius: 0,
    zIndex: 10,
  },
  noTicketsText: {
    textAlign: "center",
    color: "rgb(104, 121, 146)",
    fontSize: "14px",
    lineHeight: "1.4",
  },
  connectionTag: {
    background: "green",
    color: "#FFF",
    marginRight: 4,
    marginBottom: 2,
    padding: "4px 8px",
    fontWeight: 600,
    borderRadius: 6,
    fontSize: "0.75em",
    whiteSpace: "nowrap",
    display: "inline-block",
    boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  noTicketsTitle: {
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    margin: "0px",
  },

  contactNameWrapper: {
    display: "flex",
    justifyContent: "space-between",
    marginLeft: "3px", // ✅ REDUCIDO: De 5px a 3px
    marginBottom: "2px", // ✅ NUEVO: Pequeño margen inferior para compactar
  },

  lastMessageTime: {
    textAlign: "center",
    position: "relative", // ✅ CAMBIADO: De absolute a relative - Para estar dentro del contenedor
    marginBottom: "4px", // ✅ NUEVO: Margen inferior para separarlo de los botones
    borderRadius: 10, // ✅ REDUCIDO: De 12 a 10
    padding: "2px 6px", // ✅ REDUCIDO: De 3px 8px a 2px 6px - Más pequeño
    fontSize: '0.6em', // ✅ REDUCIDO: De 0.65em a 0.6em - Texto más pequeño
    fontWeight: 500,
    zIndex: 20,
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.08)", // ✅ REDUCIDO: Sombra más sutil
    letterSpacing: "0.15px", // ✅ REDUCIDO: De 0.2px a 0.15px
    fontFamily: "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
    textTransform: "none",
    transition: "all 0.2s ease",
    pointerEvents: "none",
    whiteSpace: "nowrap",
    lineHeight: "1.2",
    display: "inline-block", // ✅ NUEVO: Para que se comporte como inline-block
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.1)",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: '0.55em', // ✅ REDUCIDO: De 0.6em a 0.55em
      padding: "2px 5px", // ✅ REDUCIDO: De 2px 6px a 2px 5px
      borderRadius: 8, // ✅ REDUCIDO: De 10 a 8
    },
  },

  closedBadge: {
    alignSelf: "center",
    justifySelf: "flex-end",
    marginRight: 32,
    marginLeft: "auto",
  },

  contactLastMessage: {
    paddingRight: "0%",
    marginLeft: "0px",
    marginTop: "2px", // ✅ REDUCIDO: De 4px a 2px
    fontSize: "12px", // ✅ REDUCIDO: De 13px a 12px
    lineHeight: "1.3", // ✅ REDUCIDO: De 1.4 a 1.3 - Más compacto
    color: theme.palette.text.secondary,
  },


  badgeStyle: {
    color: "white",
    backgroundColor: green[500],
  },

  ticketQueueColor: {
    flex: "none",
    width: "4px",
    height: "100%",
    position: "absolute",
    top: "0%",
    left: "0%",
    borderRadius: "12px 0 0 12px",
    boxShadow: "0 0 8px rgba(0,0,0,0.1)",
  },

  ticketInfo: {
    position: "relative",
    top: -13
  },
  secondaryContentSecond: {
    display: 'flex',
    alignItems: "flex-start",
    flexWrap: "wrap",
    flexDirection: "row",
    alignContent: "flex-start",
    gap: "4px", // ✅ REDUCIDO: De 6px a 4px - Menos espacio entre elementos
    marginBottom: "6px", // ✅ REDUCIDO: De 12px a 6px - Menos espacio inferior
    marginTop: "2px", // ✅ NUEVO: Pequeño margen superior para mejor alineación
  },

  // ✅ ESTILOS PARA BOTONES CON ICONOS
  actionIconButton: {
    minWidth: "24px",
    height: "24px",
    borderRadius: "6px",
    border: "1px solid #e0e0e0",
    backgroundColor: "#fff",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    padding: "4px",
    "& svg": {
      fontSize: "16px",
    },
    "&:hover": {
      backgroundColor: "#f5f5f5",
      transform: "translateY(-1px)",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    },
    "&:disabled": {
      opacity: 0.6,
      cursor: "not-allowed",
    },
  },
  
  // ✅ ESTILO PARA ICONO DE WHATSAPP
  whatsappIconButton: {
    minWidth: "28px",
    height: "28px",
    borderRadius: "6px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    cursor: "pointer",
    padding: "4px",
    "&:hover": {
      transform: "translateY(-1px)",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
    },
  },

  acceptButton: {
    color: "#4caf50",
    borderColor: "#4caf50",
    backgroundColor: "rgba(76, 175, 80, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(76, 175, 80, 0.15)",
      borderColor: "#2e7d32",
      color: "#2e7d32",
    },
  },

  closeButton: {
    color: "#f44336",
    borderColor: "#f44336",
    backgroundColor: "rgba(244, 67, 54, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(244, 67, 54, 0.15)",
      borderColor: "#c62828",
      color: "#c62828",
    },
  },

  transferButton: {
    color: "#2196f3",
    borderColor: "#2196f3",
    backgroundColor: "rgba(33, 150, 243, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(33, 150, 243, 0.15)",
      borderColor: "#1565c0",
      color: "#1565c0",
    },
  },

  reopenButton: {
    color: "#ff9800",
    borderColor: "#ff9800",
    backgroundColor: "rgba(255, 152, 0, 0.08)",
    "&:hover": {
      backgroundColor: "rgba(255, 152, 0, 0.15)",
      borderColor: "#ef6c00",
      color: "#ef6c00",
    },
  },
  ticketInfo1: {
    position: "relative",
    top: 13,
    right: 0
  },
  Radiusdot: {
    "& .MuiBadge-badge": {
      borderRadius: 2,
      position: "inherit",
      height: 16,
      margin: 2,
      padding: 3
    },
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      transform: "scale(1) translate(0%, -40%)",
    },
  },
    presence: {
    color: theme?.mode === 'light' ? "blue" : "lightgreen",
    fontWeight: "bold",
  },
  ticketNumber: {
    fontSize: "11px",
    fontWeight: "700",
    color: theme.palette.text.secondary,
    textAlign: "center",
    marginTop: "4px",
    lineHeight: "1.2",
    width: "100%",
    letterSpacing: "0.5px",
    opacity: 0.8,
  },

  avatarActive: {
    width: "48px", // ✅ REDUCIDO: De 56px a 48px
    height: "48px", // ✅ REDUCIDO: De 56px a 48px
    borderRadius: "12px", // ✅ REDUCIDO: De 14px a 12px
    boxShadow: "0 2px 6px rgba(0,0,0,0.12)", // ✅ REDUCIDO: Sombra más sutil
    border: `2px solid ${theme.palette.background.paper}`, // ✅ REDUCIDO: De 3px a 2px
  },

  avatarPending: {
    width: "44px", // ✅ REDUCIDO: De 52px a 44px
    height: "44px", // ✅ REDUCIDO: De 52px a 44px
    borderRadius: "10px", // ✅ REDUCIDO: De 12px a 10px
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // ✅ REDUCIDO: Sombra más sutil
    border: `2px solid ${theme.palette.background.paper}`,
    opacity: 0.85,
  },

  avatarContainer: {
    position: "relative",
    display: "inline-block",
  },

  agentAvatarBadge: {
    position: "absolute",
    bottom: -2,
    right: -2,
    border: `2px solid ${theme.palette.background.paper}`,
    borderRadius: "50%",
    width: "28px",
    height: "28px",
    boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
  },

  agentAvatar: {
    width: "100%",
    height: "100%",
    borderRadius: "50%",
  },
}));

const TicketListItemCustom = ({ ticket, status }) => {
  const classes = useStyles();
  const theme = useTheme();
  const { getTimeAgo } = useTimezone(); // ✅ NUEVO: Para acceder al theme en el componente
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState([]);
  const [ticketUser, setTicketUser] = useState(null);
  const [lastInteractionLabel, setLastInteractionLabel] = useState('');
  const [openTicketMessageDialog, setOpenTicketMessageDialog] = useState(false);
  const { ticketId } = useParams();
  const isMounted = useRef(true);
  const { setCurrentTicket } = useContext(TicketsContext);
  const { user } = useContext(AuthContext);
  const { whatsApps } = useContext(WhatsAppsContext);
  const { profile } = user || {};
  const [transferTicketModalOpen, setTransferTicketModalOpen] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [contactId, setContactId] = useState(null);
  const presenceMessage = { composing: "Digitando...", recording: "Gravando..." };

  // ✅ Helper para evitar setState después de unmount (fix warning React)
  const safeSetLoading = (value) => {
    if (isMounted.current) setLoading(value);
  };
  
  // ✅ Obtener estado de WhatsApp desde el contexto (más actualizado)
  const ticketWhatsApp = ticket?.whatsappId 
    ? whatsApps.find(w => w.id === ticket.whatsappId)
    : null;
  const whatsappStatus = ticketWhatsApp?.status || ticket?.whatsapp?.status || "DISCONNECTED";
  const isWhatsAppConnected = whatsappStatus === "CONNECTED";
  
  // ✅ Funciones para manejar el menú desplegable
  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
  };
  
  const menuOpen = Boolean(menuAnchorEl);
  
  // ✅ Funciones para las acciones del menú
  const handleResolve = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "closed",
        userId: user?.id,
      });
      toast.success("Ticket resuelto correctamente");
      // ✅ ELIMINADO: history.push(`/tickets/`) - No recargar página, confiar en eventos socket
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleResolveWithoutFarewell = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "closed",
        userId: user?.id,
        sendFarewell: false,
      });
      toast.success("Ticket resuelto sin despedida");
      // ✅ ELIMINADO: history.push(`/tickets/`) - No recargar página, confiar en eventos socket
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleReturn = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        status: "pending",
        userId: null,
      });
      toast.success("Ticket devuelto correctamente");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleSchedule = () => {
    if (!ticket?.id) return;
    handleMenuClose();
    setContactId(ticket.contact?.id);
    setScheduleModalOpen(true);
  };

  const handleMarkAsUnread = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        unreadMessages: 1,
      });
      toast.success("Ticket marcado como no leído");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleKeepWithMe = async () => {
    if (!ticket?.id) return;
    handleMenuClose();
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${ticket.id}`, {
        userId: user?.id,
      });
      toast.success("Ticket asignado a ti");
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  const handleDelete = () => {
    if (!ticket?.id) return;
    handleMenuClose();
    setConfirmationOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!ticket?.id) return;
    setConfirmationOpen(false);
    safeSetLoading(true);
    try {
      await api.delete(`/tickets/${ticket.id}`);
      toast.success("Ticket eliminado correctamente");
      if (window.location.pathname.includes(`/tickets/${ticket.id}`)) {
        window.location.href = "/tickets";
      }
    } catch (err) {
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
  };

  // ✅ FUNCIÓN PARA DETERMINAR QUÉ BOTONES MOSTRAR SEGÚN EL ESTADO DEL GRUPO
  const getGroupTicketButtons = (ticket) => {
    // ✅ ATENDIENDO: Si el ticket tiene estado "open" y tiene usuario asignado, no mostrar transferir ni finalizar
    const isAttending = ticket.status === "open" && ticket.userId;
    
    if (ticket.contact && ticket.contact.isGroup) {
      // ✅ GRUPOS: Botones específicos según estado
      if (ticket.status === "pending") {
        // ✅ PENDIENTE: Solo botón ACEPTAR
        return ["accept"];
      } else if (ticket.status === "open") {
        // ✅ ABIERTO: Si está siendo atendido, sin botones. Si no, mostrar TRANSFERIR y FINALIZAR
        return isAttending ? [] : ["transfer", "finalize"];
      } else if (ticket.status === "closed") {
        // ✅ CERRADO: Botón REABRIR
        return ["reopen"];
      }
    } else {
      // ✅ CONTACTOS INDIVIDUALES: Flujo normal
      if (ticket.status === "pending") {
        return ["accept", "finalize"];
      } else if (ticket.status === "open") {
        // ✅ ABIERTO: Si está siendo atendido, sin botones. Si no, mostrar TRANSFERIR y FINALIZAR
        return isAttending ? [] : ["transfer", "finalize"];
      } else if (ticket.status === "closed") {
        return ["reopen"];
      }
    }
    return [];
  };
  
  useEffect(() => {
    // ✅ CRÍTICO: Inicializar isMounted al montar el componente
    isMounted.current = true;
    
    if (ticket.userId && ticket.user) {
      if (isMounted.current) {
        setTicketUser(ticket.user?.name?.toUpperCase());
      }
    }
    
    // ✅ CRÍTICO: Actualizar tags siempre que cambien (comparar por contenido, no solo referencia)
    const currentTags = ticket?.tags || [];
    const tagsChanged = JSON.stringify(currentTags) !== JSON.stringify(tag);
    
    if ((tagsChanged || currentTags.length !== tag.length) && isMounted.current) {
      setTag([...currentTags]); // ✅ Crear nueva referencia del array
    }

    // ✅ Cleanup function: Marcar como desmontado
    return () => {
      isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticket.presence, ticket.tags, ticket.updatedAt]); // ✅ AGREGAR ticket.updatedAt PARA FORZAR RE-RENDER CUANDO SE ACTUALIZA

  const handleCloseTicket = async (id) => {
    setTag(ticket?.tags);
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "closed",
        userId: user?.id,
        queueId: ticket?.queue?.id,
        useIntegration: false,
        promptId: null,
        integrationId: null
      });
      // ✅ CORREGIDO: No navegar, los eventos socket actualizarán las listas automáticamente
      // El ticket se eliminará de la pestaña actual (group/open/pending) y aparecerá en "closed"
      toast.success(i18n.t("ticketsList.buttons.ticketClosed") || "Ticket cerrado correctamente");
    } catch (err) {
      safeSetLoading(false);
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
    // ✅ ELIMINADO: history.push(`/tickets/`) - No recargar página, confiar en eventos socket
  };

  useEffect(() => {
    // ✅ CRÍTICO: Inicializar isMounted al montar el componente
    isMounted.current = true;
    
    const renderLastInteractionLabel = () => {
      if (!ticket.lastMessage) return { labelText: '', labelColor: '' };

      // ✅ CORRECCIÓN (31/12/2025): Usar zona horaria configurada de la empresa
      // Las fechas del backend son "naive" (sin zona horaria)
      // Deben interpretarse en la zona horaria de la empresa
      return getTimeAgo(ticket.updatedAt);
    };

    // Função para atualizar o estado do componente
    let timeoutId = null;
    const updateLastInteractionLabel = () => {
      // ✅ CRÍTICO: Verificar si el componente sigue montado antes de actualizar estado
      if (!isMounted.current) {
        if (timeoutId) clearTimeout(timeoutId);
        return;
      }
      
      // ✅ CRÍTICO: Verificar nuevamente antes de actualizar estado
      if (!isMounted.current) return;
      
      const { labelText, labelColor } = renderLastInteractionLabel();
      if (!labelText) {
        if (isMounted.current) {
          setLastInteractionLabel(null);
        }
        return;
      }
      
      // ✅ CRÍTICO: Verificar nuevamente antes de actualizar estado
      if (isMounted.current) {
        setLastInteractionLabel(
          <Typography
            className={classes.lastMessageTime}
            component="span"
            variant="body2"
            style={{ 
              color: '#ffffff', 
              backgroundColor: labelColor || '#6b7280',
              boxShadow: `0 2px 8px ${labelColor || '#6b7280'}40, 0 1px 3px rgba(0, 0, 0, 0.1)`
            }}
          >
            {labelText}
          </Typography>
        );
      }
      
      // ✅ Agendando a próxima atualização após 30 segundos (solo si está montado)
      if (isMounted.current) {
        timeoutId = setTimeout(updateLastInteractionLabel, 30 * 1000);
      }
    };

    // Inicializando a primeira atualização
    updateLastInteractionLabel();

    // ✅ Cleanup function: Limpiar timeout y marcar como desmontado
    return () => {
      isMounted.current = false;
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };

  }, [ticket, classes.lastMessageTime, getTimeAgo]); // ✅ Removido isMounted de dependencias (es un ref)

  const handleReopenTicket = async (id) => {
    safeSetLoading(true);
    try {
      await api.put(`/tickets/${id}`, {
        status: "open",
        userId: user?.id,
        queueId: ticket?.queue?.id
      });
    } catch (err) {
      safeSetLoading(false);
      toastError(err);
    } finally {
      safeSetLoading(false);
    }
    history.push(`/tickets/${ticket.uuid}`);
  };

    // ✅ FUNCIÓN PARA MANEJAR ACEPTAR TICKET DE GRUPO
    const handleAcceptGroupTicket = async (id) => {
      safeSetLoading(true);
      try {
        await api.put(`/tickets/${id}`, {
          status: "open",
          userId: user?.id,
        });
        
        // ✅ NO ENVIAR MENSAJE AUTOMÁTICO PARA GRUPOS
        if (!ticket.isGroup) {
          let settingIndex;
          try {
            const { data } = await api.get("/settings/");
            settingIndex = data.filter((s) => s.key === "sendGreetingAccepted");
          } catch (err) {
            toastError(err);
          }
          
          if (settingIndex[0].value === "enabled") {
            handleSendMessage(ticket.id);
          }
        }
      } catch (err) {
        safeSetLoading(false);
        toastError(err);
      } finally {
        safeSetLoading(false);
      }
      history.push(`/tickets/${ticket.uuid}`);
    };

    // ✅ FUNCIÓN NO UTILIZADA - REEMPLAZADA POR handleAcceptGroupTicket
    // const handleAcepptTicket = async (id) => {
    //     setLoading(true);
    //     try {
    //         await api.put(`/tickets/${id}`, {
    //             status: "open",
    //             userId: user?.id,
    //         });
    //         
    //         let settingIndex;

    //         try {
    //             const { data } = await api.get("/settings/");
    //             
    //             settingIndex = data.filter((s) => s.key === "sendGreetingAccepted");
    //             
    //         } catch (err) {
    //             toastError(err);
                   
    //         }
            
    //         if (settingIndex[0].value === "enabled" && !ticket.isGroup) {
    //             handleSendMessage(ticket.id);
                
    //         }

    //     } catch (err) {
    //         setLoading(false);
            
    //         toastError(err);
    //     }
    //     if (isMounted.current) {
    //         setLoading(false);
    //     }

    //     // handleChangeTab(null, "tickets");
    //     // handleChangeTab(null, "open");
    //     history.push(`/tickets/${ticket.uuid}`);
    // };
	
	    const handleSendMessage = async (id) => {
        
        const msg = `{{ms}} *{{name}}*, meu nome é *${user?.name}* e agora vou prosseguir com seu atendimento!`;
        const message = {
            read: 1,
            fromMe: true,
            mediaUrl: "",
            body: `${i18n.t("tickets.automaticMessages.title")}:\n${msg.trim()}`,
        };
        try {
            await api.post(`/messages/${id}`, message);
        } catch (err) {
            toastError(err);
            
        }
    };

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid } = ticket;
    setCurrentTicket({ id, uuid, code });
  };


  const renderTicketInfo = () => {
    return (
      <>
        {/* Icono de chatbot movido a la posición de la fecha/hora */}
      </>
    );
  };

  const handleOpenTransferModal = () => {
    setTransferTicketModalOpen(true);
  }

  const handleCloseTransferTicketModal = () => {
    if (isMounted.current) {
      setTransferTicketModalOpen(false);
    }
  };

  // ✅ FUNCIÓN PARA RENDERIZAR BOTONES DE ACCIÓN SEGÚN EL ESTADO DEL GRUPO
  const renderActionButtons = () => {
    const buttons = getGroupTicketButtons(ticket);
    const isAttending = ticket.status === "open" && ticket.userId;
    
    // ✅ Si está siendo atendido, mostrar los 3 iconos (WhatsApp, ojo, menú)
    if (isAttending) {
    return (
        <span className={classes.secondaryContentSecond} style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "16px" }}>
          {/* ✅ ICONO DE WHATSAPP */}
          {ticket?.whatsapp && (
            <Tooltip title={`${ticket.whatsapp.name || "WhatsApp"} - ${isWhatsAppConnected ? "Conectado" : "Desconectado"}`}>
              <Box
                className={classes.whatsappIconButton}
                onClick={(e) => e.stopPropagation()}
                onMouseDown={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: isWhatsAppConnected ? green[500] : "#9e9e9e",
                  color: "#fff",
                }}
              >
                <WhatsAppIcon 
                  style={{ 
                    fontSize: "16px",
                    filter: isWhatsAppConnected ? "none" : "brightness(0.8)"
                  }} 
                />
              </Box>
            </Tooltip>
          )}
          {/* ✅ ICONO DEL OJO */}
          {profile === "admin" && (
            <Tooltip title="Espiar Conversa">
              <IconButton
                size="small"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenTicketMessageDialog(true);
                }}
                className={classes.actionIconButton}
                style={{ 
                  color: blue[600],
                  borderColor: blue[200],
                }}
              >
                <VisibilityIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </Tooltip>
          )}
          {/* ✅ MENÚ DESPLEGABLE */}
          <Tooltip title="Más opciones">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                handleMenuOpen(e);
              }}
              className={classes.actionIconButton}
              style={{ 
                color: "#666",
                borderColor: "#ddd",
              }}
            >
              <MoreVertIcon style={{ fontSize: "16px" }} />
            </IconButton>
          </Tooltip>
        </span>
      );
    }
    
    // ✅ Botones normales para otros estados
    const isPending = ticket.status === "pending";
    return (
      <span 
        className={classes.secondaryContentSecond}
        style={isPending ? { marginBottom: "16px" } : {}}
      >
        {buttons.includes("accept") && (
          <Tooltip title={i18n.t("ticketsList.buttons.accept")}>
            <span>
              <IconButton
                className={`${classes.actionIconButton} ${classes.acceptButton}`}
                size="small"
                disabled={loading}
                onClick={e => handleAcceptGroupTicket(ticket.id)}
              >
                <CheckIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {buttons.includes("transfer") && (
          <Tooltip title={i18n.t("ticketsList.buttons.transfer")}>
            <span>
              <IconButton
                className={`${classes.actionIconButton} ${classes.transferButton}`}
                size="small"
                disabled={loading}
                onClick={e => handleOpenTransferModal()}
              >
                <PeopleIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {buttons.includes("finalize") && (
          <Tooltip title={i18n.t("ticketsList.buttons.closed")}>
            <span>
              <IconButton
                className={`${classes.actionIconButton} ${classes.closeButton}`}
                size="small"
                disabled={loading}
                onClick={e => handleCloseTicket(ticket.id)}
              >
                <CloseIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}

        {buttons.includes("reopen") && (
          <Tooltip title={i18n.t("ticketsList.buttons.reopen")}>
            <span>
              <IconButton
                className={`${classes.actionIconButton} ${classes.reopenButton}`}
                size="small"
                disabled={loading}
                onClick={e => handleReopenTicket(ticket.id)}
              >
                <ReplayIcon style={{ fontSize: "16px" }} />
              </IconButton>
            </span>
          </Tooltip>
        )}
        {/* ✅ ICONO DE WHATSAPP PARA TICKETS PENDING - Muestra conexión activa */}
        {ticket.status === "pending" && ticket?.whatsapp && (
          <Tooltip title={`${ticket.whatsapp.name || "WhatsApp"} - ${isWhatsAppConnected ? "Conectado" : "Desconectado"} | Click para ver conversación`}>
            <Box
              className={classes.whatsappIconButton}
              onClick={(e) => {
                e.stopPropagation();
                setOpenTicketMessageDialog(true);
              }}
              onMouseDown={(e) => e.stopPropagation()}
              style={{
                backgroundColor: isWhatsAppConnected ? green[500] : "#9e9e9e",
                color: "#fff",
                cursor: "pointer",
              }}
            >
              <WhatsAppIcon 
                style={{ 
                  fontSize: "16px",
                  filter: isWhatsAppConnected ? "none" : "brightness(0.8)"
                }} 
              />
            </Box>
          </Tooltip>
        )}
        {/* ✅ ICONO DEL OJO - Solo para tickets que NO están en PENDING */}
        {ticket.status !== "pending" && (
          <Tooltip title="Ver conversación">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setOpenTicketMessageDialog(true);
              }}
              className={classes.actionIconButton}
              style={{ 
                color: blue[600],
                borderColor: blue[200],
              }}
            >
              <VisibilityIcon style={{ fontSize: "16px" }} />
            </IconButton>
          </Tooltip>
        )}
      </span>
    );
  };

  // ✅ Validación: si no hay ticket, no renderizar nada (después de todos los hooks)
  if (!ticket || !ticket.id) {
    return null;
  }

  return (
    <React.Fragment key={ticket.id}>

    <TransferTicketModalCustom
    modalOpen={transferTicketModalOpen}
    onClose={handleCloseTransferTicketModal}
    ticketid={ticket.id}
  />

      <TicketMessagesDialog
        open={openTicketMessageDialog}

        handleClose={() => setOpenTicketMessageDialog(false)}
        ticketId={ticket.id}
      ></TicketMessagesDialog>
      <ListItem dense button
        onClick={(e) => {
          // ✅ CORRECCIÓN 2025-12-23: Si el ticket está en PENDING, abrir en modo lectura
          if (ticket.status === "pending") {
            e.stopPropagation();
            setOpenTicketMessageDialog(true);
            return;
          }
          handleSelectTicket(ticket);
        }}
        selected={ticketId && +ticketId === ticket.id}
        className={clsx(classes.ticket, {
          [classes.pendingTicket]: ticket.status === "pending",
        })}
      >
        <Tooltip arrow placement="right" title={ticket.queue?.name?.toUpperCase() || ""} >
          <span style={{ backgroundColor: ticket.queue?.color || "#7C7C7C" }} className={classes.ticketQueueColor}></span>
        </Tooltip>
        <ListItemAvatar>
          <Box display="flex" flexDirection="column" alignItems="center" style={{ marginRight: 8, position: "relative" }}> {/* ✅ REDUCIDO: De 12px a 8px, agregado position relative */}
            <Box className={classes.avatarContainer} style={{ position: "relative" }}>
            {/* ✅ Badge de mensajes no leídos - Posicionado cerca del borde superior izquierdo del avatar (solo para PENDING) */}
            {ticket.status === "pending" && ticket.unreadMessages > 0 && (
              <Badge
                badgeContent={ticket.unreadMessages}
                classes={{
                  badge: classes.badgeStyle,
                }}
                style={{
                  position: "absolute",
                  top: "-6px", // ✅ Más abajo, cerca del borde superior izquierdo del avatar
                  left: "-6px", // ✅ Más cerca del borde izquierdo del avatar
                  zIndex: 10,
                }}
              />
            )}
          {ticket.status !== "pending" ?
            <Avatar
              key={`avatar-${ticket.id}-${ticket?.contact?.id}-${ticket?.contact?.profilePicUrl || 'no-pic'}-${ticket?.contact?.updatedAt || ''}`}
                  className={classes.avatarActive}
              style={{
                backgroundColor: generateColor(ticket?.contact?.number),
              }}
              src={(ticket?.contact?.profilePicUrl && 
                     ticket.contact.profilePicUrl !== "" && 
                     !ticket.contact.profilePicUrl.includes("nopicture.png")) 
                     ? getProfilePicUrl(ticket.contact.profilePicUrl) 
                     : null}
              onError={(e) => {
                // ✅ FIX 05/12/2025: Si la imagen falla al cargar, ocultar para mostrar iniciales
                if (e.target) {
                  e.target.style.display = 'none';
                }
              }}>
              {getInitials(ticket?.contact?.name || "")}
              </Avatar>
            :
            <Avatar
              key={`avatar-${ticket.id}-${ticket?.contact?.id}-${ticket?.contact?.profilePicUrl || 'no-pic'}-${ticket?.contact?.updatedAt || ''}`}
                  className={classes.avatarPending}
              style={{
                backgroundColor: generateColor(ticket?.contact?.number),
              }}
              src={(ticket?.contact?.profilePicUrl && 
                     ticket.contact.profilePicUrl !== "" && 
                     !ticket.contact.profilePicUrl.includes("nopicture.png")) 
                     ? getProfilePicUrl(ticket.contact.profilePicUrl) 
                     : null}
              onError={(e) => {
                // ✅ FIX 05/12/2025: Si la imagen falla al cargar, ocultar para mostrar iniciales
                if (e.target) {
                  e.target.style.display = 'none';
                }
              }}>
              {getInitials(ticket?.contact?.name || "")}
              </Avatar>
          }
              {/* ✅ AVATAR DEL AGENTE SUPERPUESTO */}
              {(ticket.user || ticket.userId) && (
                <Tooltip title={(ticket.user?.name || ticketUser || "")} arrow>
                  <Box className={classes.agentAvatarBadge}>
                    <Avatar
                      className={classes.agentAvatar}
                      src={ticket.user?.profilePicUrl && !ticket.user.profilePicUrl.includes("nopicture.png")
                        ? getProfilePicUrl(ticket.user.profilePicUrl)
                        : null}
                      style={{
                        backgroundColor: generateColor(ticket.user?.name || ticketUser || ticket.userId?.toString() || ""),
                        fontSize: "12px",
                        fontWeight: "bold",
                      }}
                      onError={(e) => {
                        if (e.target) {
                          e.target.style.display = 'none';
                        }
                      }}
                    >
                      {getInitials(ticket.user?.name || ticketUser || "")}
                    </Avatar>
                  </Box>
                </Tooltip>
              )}
            </Box>
            {/* ✅ NUEVO: Mostrar nombre del usuario que atiende (solo para ADMIN en ATENDIENDO) */}
            {profile === "admin" && ticket.status === "open" && (ticket.user || ticket.userId) && (
              <Typography
                variant="caption"
                style={{
                  marginTop: "4px",
                  fontSize: "10px",
                  color: theme.palette.text.secondary,
                  textAlign: "center",
                  maxWidth: "60px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  fontWeight: 500,
                }}
              >
                {ticket.user?.name || ticketUser || ""}
              </Typography>
            )}
          </Box>
        </ListItemAvatar>
        <ListItemText
          disableTypography

          primary={
            <span className={classes.contactNameWrapper}>
            <Typography
            noWrap
            component='span'
            variant='body2'
            color='textPrimary'
          >
            <strong>{ticket?.contact?.name || 'Contacto sin nombre'}</strong>
        <ListItemSecondaryAction>
          <Box className={classes.ticketInfo1}>{renderTicketInfo()}</Box>
        </ListItemSecondaryAction>
              </Typography>
        </span>

          }
          secondary={
            <span className={classes.contactNameWrapper}>

              <Typography
                className={classes.contactLastMessage}
                noWrap
                component="span"
                variant="body2"
                color="textSecondary"
              >
                {["composing", "recording"].includes(ticket?.presence) ? (
                  <span className={classes.presence}>
                    {presenceMessage[ticket.presence]}
                  </span>
                ) : (
                  <>
                    {ticket.lastMessage && ticket.lastMessage.includes('data:image/png;base64') ? 
                      <MarkdownWrapper> Localização</MarkdownWrapper> 
                      : 
                      <MarkdownWrapper>
                        {ticket.lastMessage && ticket.lastMessage.length > 30 
                          ? `${ticket.lastMessage.substring(0, 30)}...` 
                          : ticket.lastMessage || "Sin mensaje"
                        }
                      </MarkdownWrapper>
                    }
                    
                    {/* ✅ MOSTRAR REACCIONES DEL ÚLTIMO MENSAJE EN LA VISTA PREVIA */}
                    {ticket.lastMessageWithReactions && ticket.lastMessageWithReactions.length > 0 && (
                      <span style={{
                        marginLeft: '8px',
                        fontSize: '14px',
                        display: 'inline-block'
                      }}>
                        {ticket.lastMessageWithReactions[0].reactions && ticket.lastMessageWithReactions[0].reactions.length > 0 && (
                          <span style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            borderRadius: '12px',
                            padding: '2px 6px',
                            fontSize: '12px',
                            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)'
                          }}>
                            {ticket.lastMessageWithReactions[0].reactions[ticket.lastMessageWithReactions[0].reactions.length - 1].type}
                          </span>
                        )}
                      </span>
                    )}
                  </>
                )}

                <span style={{ marginTop: 2 }} className={classes.secondaryContentSecond} > {/* ✅ REDUCIDO: marginTop de 4px a 2px */}
                  {ticket.queue?.name && <Badge style={{ backgroundColor: ticket.queue?.color || "#7c7c7c" }} className={classes.connectionTag}>{ticket.queue?.name?.toUpperCase()}</Badge>}
                  {/* ✅ INDICADORES DE AGENTE IA */}
                  {ticket.chatbot && (
                    <Tooltip title="🤖 Agente IA - Chatbot activo">
                      <AndroidIcon
                        fontSize="small"
                        style={{ 
                          color: blue[600], 
                          fontSize: '16px',
                          marginLeft: '5px',
                          marginTop: '2px',
                          cursor: 'pointer'
                        }}
                      />
                    </Tooltip>
                  )}
                  
                  					{/* ✅ INDICADOR DE PROMPT IA */}
					{ticket.promptId && (
						<Tooltip title="🧠 IA Inteligente - Prompt configurado">
							<EmojiEmotionsIcon
								fontSize="small"
								style={{ 
									color: green[600], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                  
                  					{/* ✅ INDICADOR DE INTEGRACIÓN */}
					{ticket.useIntegration && (
						<Tooltip title="🔗 Integración Externa - N8N/Dialogflow">
							<SettingsIcon
								fontSize="small"
								style={{ 
									color: orange[600], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                  
                  					{/* ✅ INDICADOR DE FLOWBUILDER */}
					{/* ✅ CRÍTICO: Solo mostrar icono de FlowBuilder en pestaña "ai" */}
					{status === "ai" && (ticket.flowStatus != null || ticket.queue?.flowBuilderId) && (
						<Tooltip title="🌊 FlowBuilder - Automatización de flujos activa">
							<AccountTreeIcon
								fontSize="small"
								style={{ 
									color: green[700], 
									fontSize: '16px',
									marginLeft: '5px',
									marginTop: '2px',
									cursor: 'pointer'
								}}
							/>
						</Tooltip>
					)}
                </span>

                {/* <span style={{ marginTop: 2, fontSize: 5 }} className={classes.secondaryContentSecond} >
                  {ticket?.whatsapp?.name ? <Badge className={classes.connectionTag}>{ticket?.whatsapp?.name?.toUpperCase()}</Badge> : <br></br>}
                </span> */}

                {/*<span style={{ marginTop: 4, fontSize: 5 }} className={classes.secondaryContentSecond} >
                  {ticketUser ? <Chip size="small" icon={<FaceIcon />} label={ticketUser} variant="outlined" /> : <br></br>}
                </span>*/}

                <span style={{ paddingTop: "1px", marginTop: "2px" }} className={classes.secondaryContentSecond} > {/* ✅ REDUCIDO: paddingTop de 2px a 1px */}
                  {tag?.map((tag) => {
                    return (
                      <ContactTag tag={tag} key={`ticket-contact-tag-${ticket.id}-${tag.id}`} />
                    );
                  })}
                </span>

              </Typography>
            </span>
          }

        />
        {/* ✅ TIEMPO RELATIVO DEL TICKET - Reposicionado más cerca de los botones */}
        <ListItemSecondaryAction style={{ 
          marginTop: ticket.lastMessage ? '8px' : '0', // ✅ REDUCIDO: De 32px a 8px - Más cerca del contenido
          marginBottom: '8px', // ✅ REDUCIDO: De 16px a 8px
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'flex-end',
          gap: '4px', // ✅ NUEVO: Espacio entre badge de tiempo y botones
          right: '4px', // ✅ NUEVO: Mover botones más hacia la derecha, cerca del borde del ticket
          paddingRight: '0px' // ✅ NUEVO: Eliminar padding derecho para acercar más al borde
        }}>
          {/* ✅ Badge de tiempo reposicionado dentro de ListItemSecondaryAction */}
          {ticket.lastMessage && lastInteractionLabel}
          {renderActionButtons()}
        </ListItemSecondaryAction>

      
      </ListItem>

      <Divider variant="inset" component="li" />
      
      {/* ✅ MENÚ DESPLEGABLE CON OPCIONES - Solo cuando está siendo atendido */}
      {ticket.status === "open" && ticket.userId && (
        <Menu
          anchorEl={menuAnchorEl}
          open={menuOpen}
          onClose={handleMenuClose}
        >
          <MenuItem onClick={handleResolve}>
            <ListItemIcon>
              <CheckCircleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Resolver" />
          </MenuItem>
          <MenuItem onClick={handleResolveWithoutFarewell}>
            <ListItemIcon>
              <CheckCircleOutlineIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Resolver sin despedida" />
          </MenuItem>
          <MenuItem onClick={handleReturn}>
            <ListItemIcon>
              <ArrowBackIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Devolver" />
          </MenuItem>
          <MenuItem onClick={() => {
            handleMenuClose();
            handleOpenTransferModal();
          }}>
            <ListItemIcon>
              <PeopleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={i18n.t("ticketsList.buttons.transfer")} />
          </MenuItem>
          <MenuItem onClick={handleSchedule}>
            <ListItemIcon>
              <ScheduleIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Posponer" />
          </MenuItem>
          <MenuItem onClick={handleMarkAsUnread}>
            <ListItemIcon>
              <ChatIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Marcar como no leído" />
          </MenuItem>
          <MenuItem onClick={handleKeepWithMe}>
            <ListItemIcon>
              <LockIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Mantener conmigo" />
          </MenuItem>
          {/* ✅ Solo mostrar opción "Eliminar" para administradores */}
          {user?.profile === 'admin' && (
          <MenuItem onClick={handleDelete}>
            <ListItemIcon>
              <CloseIcon fontSize="small" style={{ color: red[500] }} />
            </ListItemIcon>
            <ListItemText primary="Eliminar" primaryTypographyProps={{ style: { color: red[500] } }} />
          </MenuItem>
          )}
        </Menu>
      )}
      
      {/* ✅ MODALES */}
      <ScheduleModal
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
          setContactId(null);
        }}
        aria-labelledby="form-dialog-title"
        contactId={contactId}
        ticketId={ticket.id}
      />
      <ConfirmationModal
        title={`¿Eliminar ticket #${ticket.id} de ${ticket.contact?.name || "contacto desconocido"}?`}
        open={confirmationOpen}
        onClose={() => setConfirmationOpen(false)}
        onConfirm={handleConfirmDelete}
      >
        Esta acción no se puede deshacer.
      </ConfirmationModal>
    </React.Fragment>
  );
};

// ✅ MEMOIZACIÓN: Solo re-renderizar si cambian propiedades relevantes
const MemoizedTicketListItemCustom = React.memo(TicketListItemCustom, (prevProps, nextProps) => {
  return (
    prevProps.ticket.id === nextProps.ticket.id &&
    prevProps.ticket.status === nextProps.ticket.status &&
    prevProps.ticket.updatedAt === nextProps.ticket.updatedAt &&
    prevProps.ticket.unreadMessages === nextProps.ticket.unreadMessages &&
    prevProps.ticket.userId === nextProps.ticket.userId &&
    prevProps.ticket.presence === nextProps.ticket.presence &&
    prevProps.ticket.lastMessage?.id === nextProps.ticket.lastMessage?.id
  );
});

MemoizedTicketListItemCustom.displayName = 'TicketListItemCustom';

export default MemoizedTicketListItemCustom;
